import Input from './Input'

export * from './Input'
export default Input
